export const CONTAINER_CLASS =
    "max-w-auto mx-auto xl:h-[600px] flex justify-center";
export const INNER_CONTAINER = "my-auto mx-2 md:mx-4 lg:mx-2 xl:mx-12 ";
export const ARABIC_INNER_CONTAINER =
    "my-auto mx-2 md:mx-4 lg:mx-2 xl:mx-12 lg:row-start-1";
export const VALUES_CONATINER =
    " mx-auto grid grid-cols-3 gap-x-2 md:gap-x-12 gap-y-4 md:gap-y-14";
export const BREAK_POINT_WIDTH = 540;
